import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { img } from '../../../assets/icon'
import { getStyleFromTextConfig } from '../../../utils/style'
import { Bonuses } from '../../Bonuses/Bonuses'
import { Button } from '../../Button/Button'
import { Desktop } from '../../Container/Desktop'
import { Mobile } from '../../Container/Mobile'
import { Discount } from '../../Discount/Discount'
import { DiscountProgress } from '../../DiscountProgress/DiscountProgress'
import { TextLabel } from '../../TextLabel/TextLabel'
import {
    ThumbImage,
    Image,
    ContentBox,
    TextBox,
    Title,
    Text,
    SecondTitle,
    BonusesTitle,
    Video,
    TotalBox,
    TotalText,
    TotalSum,
    ButtonBox,
    BonusesContainer,
    BoxBonuse,
} from './ResultItemOne.styled'
import { getProgressDiscount } from '../../../utils/progressDiscount'
import { useTranslation } from '../../../hooks/useTranslation'
import { useUnits } from '../../../hooks/useUnits'

type Props = {
    result: any
    currency: any
    //button_style?: number;
    addition_page_display?: number
    additions: any[]
    after_contacts: boolean
    onNext: () => void
    onBack?: () => void
    showBackButton?: boolean
    lockBonus: boolean
}

export const ResultItemOne: FC<Props> = ({
    result: {
        title,
        description,
        description_short,
        description_config,
        print_total,
        button,
        add_image,
        image,
        video_link,
        button_text,
        button_link,
        //calculation_type,
        calculation_config,
        ...rest
    },
    currency,
    //button_style,
    addition_page_display,
    additions,
    after_contacts,
    onNext,
    onBack,
    lockBonus,
    showBackButton = false,
}) => {
    const { t } = useTranslation()
    const mobileButtonWrapper = useRef<HTMLDivElement | null>(null)
    const [mobileHeightBtns, setMobileHeightBtns] = useState<number>(0)

    const calculation_type = rest?.calculation_type ?? 1
    const units = useUnits()

    const additionsWithoutConsultant = useMemo(() => additions.filter(({ type }) => type !== 3), [additions])

    const discountProgress = useMemo(
        () => additions.find(({ type, config }) => type === 2 && config.typeDiscount === 2),
        [additions]
    )
    const isDiscountProgress = !!discountProgress

    const discountProgressValue = discountProgress
        ? getProgressDiscount(
              discountProgress.config?.discountValue,
              1,
              1,
              discountProgress.config?.unitDiscount,
              currency?.title
          )
        : ''
    const lengthArray = additionsWithoutConsultant.length + +isDiscountProgress

    useEffect(() => {
        if (mobileButtonWrapper.current) {
            setMobileHeightBtns(mobileButtonWrapper.current.offsetHeight)
        }
    }, [])

    return (
        <>
            <ThumbImage>
                {add_image ? (
                    <Image src={image ?? img} title="result image" />
                ) : (
                    video_link && (
                        <Video
                            url={video_link}
                            width="100%"
                            height="100%"
                            config={{
                                youtube: {
                                    // playerVars: { modestbranding: 1, controls:0, showinfo:0 },
                                },
                            }}
                        />
                    )
                )}
                {print_total && (
                    <TotalBox>
                        <TotalText>
                            {!calculation_config.unit &&
                                (units.find(({ id }) => id === calculation_config.unit)?.title ?? units[0]?.title)}
                        </TotalText>
                        <TotalSum>
                            {!calculation_config.unit
                                ? `${currency?.title} `
                                : `${units[calculation_config.unit]?.title} `}

                            {calculation_type === 1 &&
                                (calculation_config?.useSingleValue
                                    ? `${calculation_config?.resultValue ?? 0}`
                                    : `${calculation_config?.resultValueFrom ?? 0} - ${
                                          calculation_config?.resultValueTo ?? 0
                                      }`)}
                            {calculation_type === 2 && (rest.formula_result || 0)}
                            {calculation_type === 3 && (rest.sum_points || 0)}
                        </TotalSum>
                    </TotalBox>
                )}
            </ThumbImage>
            <ContentBox mobileButtonsHeight={mobileHeightBtns}>
                <TextBox>
                    <Title>{title}</Title>
                    <SecondTitle>{description_short}</SecondTitle>
                    <Text style={getStyleFromTextConfig(description_config)}>{description}</Text>

                    <ButtonBox ref={mobileButtonWrapper}>
                        {(addition_page_display === 1 || addition_page_display === 3) && (
                            <Mobile>
                                <BonusesContainer>
                                    {additionsWithoutConsultant.length > 0 && (
                                        <>
                                            <BonusesTitle>{t('getYourBonus')}</BonusesTitle>
                                            <BoxBonuse length={lengthArray}>
                                                {additionsWithoutConsultant.map((item) => {
                                                    if (item.type === 2)
                                                        return (
                                                            <Discount
                                                                key={item.id}
                                                                addition={item}
                                                                lockBonus={lockBonus}
                                                                disabledDecor={true}
                                                            />
                                                        )
                                                    return (
                                                        <Bonuses
                                                            key={item.id}
                                                            addition={item}
                                                            lockBonus={lockBonus}
                                                            disabledDecor={true}
                                                        />
                                                    )
                                                })}
                                                {additionsWithoutConsultant.length < 3 && isDiscountProgress && (
                                                    <DiscountProgress
                                                        text={t('yourDiscount')}
                                                        value={discountProgressValue}
                                                    />
                                                )}
                                            </BoxBonuse>
                                        </>
                                    )}
                                    <TextLabel
                                        style={{
                                            backgroundColor: 'transparent',
                                            marginBottom: '20px',
                                        }}
                                    />
                                </BonusesContainer>
                            </Mobile>
                        )}
                        {(button || !after_contacts) && (
                            <Button
                                //type={button_style}
                                isHideArrow={false}
                                isShowBack={showBackButton}
                                title={button_text}
                                onNext={onNext}
                                onPrev={onBack}
                            />
                        )}
                    </ButtonBox>
                </TextBox>
                {(addition_page_display === 1 || addition_page_display === 3) && (
                    <Desktop>
                        <BonusesContainer>
                            {additionsWithoutConsultant.length > 0 && (
                                <>
                                    {additions.some(({ type, config }) => type === 2 && config.typeDiscount === 2) && (
                                        <DiscountProgress
                                            text={t('yourDiscount')}
                                            style={{ alignItems: 'center', marginBottom: '10px' }}
                                            value={discountProgressValue}
                                        />
                                    )}
                                    <BonusesTitle>{t('getYourBonus')}</BonusesTitle>
                                    <BoxBonuse length={lengthArray}>
                                        {additions
                                            .filter(({ type }) => type !== 3)
                                            .map((item) => {
                                                if (item.type === 2)
                                                    return (
                                                        <Discount
                                                            key={item.id}
                                                            addition={item}
                                                            style={{ width: '100%', marginBottom: '10px' }}
                                                            lockBonus={lockBonus}
                                                            disabledDecor={true}
                                                        />
                                                    )
                                                return (
                                                    <Bonuses
                                                        key={item.id}
                                                        addition={item}
                                                        style={{ width: '100%', marginBottom: '10px' }}
                                                        lockBonus={lockBonus}
                                                        disabledDecor={true}
                                                    />
                                                )
                                            })}
                                    </BoxBonuse>
                                </>
                            )}
                            <TextLabel style={{ marginBottom: '-10px' }} />
                        </BonusesContainer>
                    </Desktop>
                )}
            </ContentBox>
        </>
    )
}
